import { PaperClipOutlined } from '@ant-design/icons'
import { Button, Card, Flex, Table, Typography } from 'antd'
import { ColumnsType } from 'antd/es/table'
import dayjs from 'dayjs'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { useInstitutionServiceGetListTechnicalInspectionEndpoint } from 'src/api/queries'
import { GetListTechnicalInspectionResponseItem } from 'src/api/requests'
import { onDownloadFile, useTablePagination, useUser } from 'src/hooks'
import { dayMonthYearFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'

import { TechnicalInspectionsModal } from './TechnicalInspectionsModal'

export const TechnicalInspectionsCard = () => {
  const { t } = useLocales()
  const { id } = useParams()
  const { userData } = useUser()

  const pagination = useTablePagination()
  const [isOpen, setIsOpen] = useState(false)

  const queryParams = {
    pageNumber: Number(pagination.current),
    pageSize: Number(pagination.pageSize),
    deviceIds: [String(id)],
    institutionsIds: [String(userData?.currentLegalEntityId)]
  }

  const { data, isLoading } =
    useInstitutionServiceGetListTechnicalInspectionEndpoint(
      queryParams,
      [queryParams],
      { enabled: !!id }
    )

  const columns: ColumnsType<GetListTechnicalInspectionResponseItem> = [
    {
      key: 'examination date',
      title: t('equipments.examination_date'),
      render: (_, { executionDate }) =>
        dayjs.utc(executionDate).tz().format(dayMonthYearFormatWithDot)
    },
    {
      key: 'media files',
      title: t('stock_applications.uploaded_documents'),
      render: (_, { mediaFiles }) => (
        <Flex vertical gap={2}>
          {mediaFiles?.map((item) => (
            <Typography.Link
              className="fit-content"
              onClick={() => onDownloadFile(t, item.id, item.name)}
            >
              <Flex gap={4}>
                <PaperClipOutlined />

                {item.name}
              </Flex>
            </Typography.Link>
          ))}
        </Flex>
      )
    },
    {
      key: 'description',
      title: t('common.description'),
      dataIndex: 'description'
    }
  ]

  const onToggle = () => setIsOpen((prev) => !prev)

  return (
    <Card title={t('equipments.technical_inspections')}>
      <Flex vertical gap={24}>
        <Flex justify="flex-end">
          <Button type="primary" onClick={onToggle}>
            {t('equipments.add_inspection')}
          </Button>
        </Flex>

        <Table
          rowKey="id"
          columns={columns}
          loading={isLoading}
          dataSource={data?.data}
          bordered
          pagination={{ ...pagination, total: data?.totalCount }}
        />
      </Flex>

      {isOpen && <TechnicalInspectionsModal onCancel={onToggle} />}
    </Card>
  )
}
